<template>
  <div
    class="time-input"
    :class="{'time-input_disabled': disabled}"
    v-click-outside="onClose"
  >
    <div
      class="placeholder"
      @click="onToggleDropdown"
    >
      {{ activeLabel }}
    </div>

    <div
      v-if="open"
      class="dropdown"
    >
      <TimeDropdown
        :times="times"
        @choose="onChoose"
      />
    </div>
  </div>
</template>

<script>
import TimeDropdown from './TimeDropdown'

export default {
  name: 'TimeRange',
  components: { TimeDropdown },
  directives: {
    clickOutside: {
      beforeMount (el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event, el)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    times: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false,
      active: this.modelValue
    }
  },
  computed: {
    activeLabel () {
      const activeItem = this.times.find(i => i.value === this.active)

      if (!activeItem) {
        return '--:--'
      }

      return activeItem.text
    }
  },
  methods: {
    onChoose (event) {
      this.active = event.value
      this.$emit('update:modelValue', event.value)
    },
    onToggleDropdown () {
      this.open = !this.open
    },
    onClose () {
      this.open = false
    },
    onOpen () {
      this.open = true
    }
  },
  watch: {
    modelValue (value) {
      this.active = value
    }
  }
}
</script>

<style lang="scss" scoped>
.time-input {
  position: relative;
  user-select: none;

  &_disabled {
    pointer-events: none;
  }

  .placeholder {
    height: 42px;
    background: #242428;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid transparent;
    cursor: pointer;
  }

  .dropdown {
    position: absolute;
    left: 0;
    bottom: -10px;
    transform: translateY(100%);
    width: 320px;
    background: #242428;
    padding: 10px;
    z-index: 1;
  }
}
</style>
